/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Resource', ['ngResource', 'access.Config'])
    .config(['$provide', function($provide){
        $provide.decorator('$resource', ['$delegate', '$filter', function ($delegate, $filter) {

            // Return a new constructor function that prepends an API
            // prefix to the passed resource URL (first parameter).
            return function decoratedResource() {
                arguments[0] = $filter('apiAddress')(arguments[0]);
                return $delegate.apply(this, arguments);
            };
        }]);
    }]);
